"use client";
import { InputGroup, Form } from "react-bootstrap";
import { BsSearch } from "react-icons/bs";
import { ChangeEvent } from "react";
import { Stack } from "react-bootstrap";
import { useI18n } from "../../i18n";
type SearchInputProps = {
  searchValue: string;
  setSearchValueFunc: (val: string) => void;
};

export default function SearchInput({
  searchValue,
  setSearchValueFunc,
}: SearchInputProps) {
  const { t } = useI18n();
  const onSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (typeof setSearchValueFunc === "function") {
      setSearchValueFunc(event.target.value);
    }
  };

  return (
    <Stack gap={2}>
      <InputGroup style={{ maxWidth: "60.6%" }}>
        <InputGroup.Text>
          <BsSearch />
        </InputGroup.Text>
        <Form.Control
          value={searchValue}
          onChange={onSearchChange}
          aria-label="Search"
          placeholder={t("common.search")}
        />
      </InputGroup>
    </Stack>
  );
}
